const listExport = {}
let generate = (studentList,name) =>{
    let dates = getDates(studentList);
    let attendance = buildTable(studentList, dates);
    console.log(attendance);
    let blob = new Blob([textOut(attendance)],{ type: "text/plain;charset=utf-8" });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${name}.csv`;
    link.click();
    link.remove();
}
const getDates = (studentList) =>{
    // Sort the dates.
    let dates = [];
    for(let student of studentList){
        if(student.attendance !== undefined){
            for(let date of student.attendance){
                dates.push([date,new Date(date).getTime()]);
            }
        }
    }
    if(dates.length === 0){
        return [];
    }
    let sort = [];
    let sortOut = (date,index) => {
        if(sort[index] === undefined){
            sort[index] = date;
        }else if(sort[index][1] >= date[1]){
            sortOut(date,index*2)
        }else{
            sortOut(date,index*2+1)
        }
    }
    for(let date of dates){
        sortOut(date,1);
    }
    dates = []
    let printOut = (index) =>{
        if(sort[index*2] !== undefined){
            printOut(index*2);
        }
        dates.push(sort[index])
        if(sort[index*2+1] !== undefined){
            printOut(index*2+1)
        }
    }
    printOut(1);
    
    dates = dates.map((date)=>{
        return date[0]
    })


    // Create a sets of the dates.
    let toReturn = [];
    for(let date of dates){
        if(!toReturn.includes(date)){
            toReturn.push(date);
        }
    }

    return toReturn;
}
const buildTable = (studentList,dates) =>{
    let attendance = [[new Date().toDateString(), ...dates]];
    for(let student of studentList){
        let row = []
        for(let date of dates){
            if(student.attendance === undefined){
                row.push(false);
                continue;
            }
            if(student.attendance.includes(date)){
                row.push(true)
                continue;
            }
            row.push(false)
        }
        attendance.push([student.name,...row])
    }
    return attendance;
}
const textOut = (attendance) =>{
    let toReturn = ''
    for(let line in attendance){
        for(let col in attendance[0]){
            toReturn += attendance[line][col];
            if (attendance[0].length - 1 !== col) {
                toReturn += ','
            }
        }
        toReturn += '\n';
    }
    return toReturn
}
listExport.generate = generate;
listExport.getDates = getDates;
listExport.buildTable = buildTable;


export default listExport